export const APIENDPOINTURL = "https://midwestlockouts.net/c/endpoint.php";
export const SITEURL = "https://agents.matthewkontos.com";

export const BUYSTEPURL = `${SITEURL}/step/100`

export const COMPANYFRIENDLYPHONE = "(773) 912-0126";
export const COMPANYTELPHONE = "+17739120127";